import { HttpContextToken } from '@angular/common/http';

export const PARSE_DATES = new HttpContextToken<boolean>(() => true);